import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { useHandlerWhenClickedOutside } from "@hooks";
import { tempFixFilterAttributes } from "@temp/components/ProductDetails/utils";
import upperFirst from "lodash/upperFirst";
import React from "react";
import { useIntl } from "react-intl";
import Media from "react-media";
import { Overlay } from "..";
import { mediumScreen } from "../../../../globalStyles/scss/variables.scss";
import { AttributeTypeFilterInput } from "./AttributeTypeFilterInput";
import * as S from "./styles";
export var FilterSidebar = function FilterSidebar(_ref) {
  var hide = _ref.hide,
      filters = _ref.filters,
      show = _ref.show,
      attributes = _ref.attributes,
      target = _ref.target,
      onAttributeFiltersChange = _ref.onAttributeFiltersChange,
      clearFilters = _ref.clearFilters,
      activeFilters = _ref.activeFilters;
  var intl = useIntl();

  var _useHandlerWhenClicke = useHandlerWhenClickedOutside(function () {
    hide();
  }),
      setElementRef = _useHandlerWhenClicke.setElementRef;

  var filtersJsx = React.createElement(S.Wrapper, {
    ref: setElementRef(),
    "data-cy": "filter-sidebar"
  }, React.createElement(S.CloseButton, {
    onClick: hide,
    type: "button"
  }), React.createElement(S.Header, null, React.createElement("span", null, intl.formatMessage(_defineProperty({
    defaultMessage: "FILTERS",
    "id": "@next.components.organisms.FilterSidebar.FilterSidebar.406136781"
  }, "id", "@next.components.organisms.FilterSidebar.FilterSidebar.406136781"))), React.createElement(S.ActiveFilters, null, React.createElement("span", null, activeFilters))), attributes && tempFixFilterAttributes(attributes) // TODO: temp fix. REMOVE
  .map(function (_ref2) {
    var id = _ref2.id,
        name = _ref2.name,
        slug = _ref2.slug,
        values = _ref2.values,
        translation = _ref2.translation,
        choiceType = _ref2.choiceType;
    var title = upperFirst((translation === null || translation === void 0 ? void 0 : translation.name) || name || slug).replace("-", " ");
    return React.createElement(S.FilterGroup, {
      key: id
    }, React.createElement(S.FilterTitle, null, title), React.createElement(AttributeTypeFilterInput, {
      choiceType: choiceType,
      onAttributeFiltersChange: onAttributeFiltersChange,
      filters: filters,
      values: values,
      slug: slug
    }));
  }), React.createElement(S.ButtonFilterGroup, null, React.createElement(S.DoneButton, {
    className: "red",
    onClick: hide
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Done",
    "id": "@next.components.organisms.FilterSidebar.FilterSidebar.2578844291"
  }, "id", "@next.components.organisms.FilterSidebar.FilterSidebar.2578844291"))), React.createElement(S.ClearButton, {
    type: "button",
    onClick: clearFilters
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Reset filters",
    "id": "@next.components.organisms.FilterSidebar.FilterSidebar.2724947057"
  }, "id", "@next.components.organisms.FilterSidebar.FilterSidebar.2724947057")))));
  return React.createElement(Media, {
    query: {
      maxWidth: mediumScreen
    }
  }, function (matches) {
    return matches ? React.createElement(Overlay, {
      duration: 0,
      position: "bottom",
      show: show,
      hide: hide,
      target: target
    }, filtersJsx) : filtersJsx;
  });
};
FilterSidebar.displayName = "FilterSidebar";